import type { AxiosRequestConfig, AxiosResponse } from 'axios';

export function getAxios<T>(config: AxiosRequestConfig): Promise<AxiosResponse<T>> {
	return config as any;
}
